import styled from 'styled-components';

import { Button } from 'components/Button/Button';
import { Portal } from 'components/Portal';
import { Body } from 'components/Text/Body';
import { H2 } from 'components/Text/H2';
import { Modal } from 'modals/Modal';

type Props = {
  onConfirm: () => void;
  onClose: () => void;
};

const ModalWrapper = styled.div`
  margin-top: 8px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 8px;
`;

export function SVGConfirmationModal({ onClose, onConfirm }: Props) {
  return (
    <Portal>
      <Modal wide onClose={onClose} data-qa-id="svg-upload-warning">
        <ModalWrapper>
          <H2>{getText('Warning!')}</H2>
          <Body>
            {getText(
              'SVG files downloaded from the Internet may contain malicious code that makes Idealist vulnerable to attacks. Please upload ONLY files that have been exported directly from a design tool or been vetted by design.',
            )}
          </Body>
          <ButtonContainer>
            <Button variant="danger" onClick={onConfirm}>
              {getText('Continue')}
            </Button>
            <Button variant="primary" onClick={onClose}>
              {getText('Nevermind, Go Back')}
            </Button>
          </ButtonContainer>
        </ModalWrapper>
      </Modal>
    </Portal>
  );
}
